import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";
import {Batiment} from '../Models/Batiment';
import {AnalyticsService} from "../services/analytics.service";
import * as _ from 'lodash';
import {ROUTES_PATHS} from "../const/routes";
import {specialRenovationTypesNrjNb} from "../const/utils";

@Component({
	selector: 'app-batiment',
	templateUrl: './batiment.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./batiment.component.less']
})
export class BatimentComponent implements OnInit {
	options: any;
	optionsIni: any;
	textes: any = "";
	globalTxt: any = "";
	arrParamsBienFormatted: any = [];
	arrParamsBienFormattedIni: any = [];
	arrParamsNrjFormatted: any = [];
	arrParamsNrjFormattedIni: any = [];
	typeTest: any;
	batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
	showErr: boolean = false;
	modalsTxt: any = null;
	renovationValue: number = -1;
	showSelectNbNiveaux: boolean = false;
	showSelectDpe: boolean = false;
	prmSurfacesNiveau: any = {};
	prmDpe: any = {};

	constructor(
		public app: AppComponent,
		public analyticsService: AnalyticsService
	) {
	}

	ngOnInit(): void {
		if (!this.app.sharedToolsService.getIfSessionExists()) {
			this.app.router.navigate(['/']);
			return;
		}

		let renovation: any = localStorage.getItem("RENOVATION");

		// Utilisation de la map pour obtenir la valeur numérique
		this.renovationValue = this.app.sharedToolsService.getRenovationValue(renovation);
		console.log("this.renovationValue: ", this.renovationValue);

		this.app.sharedToolsService.getJSON("selectOpts").subscribe(opts => {
			this.options = cloneDeep(opts);
			console.log("this.options: ", this.options);
		});

		// Get the modal texts
		this.app.dataInitService.getModalTextsOnce(modalsTxt => {
			this.modalsTxt = modalsTxt;
		});

		// Load the nameJson and initialize the component
		this.app.dataInitService.getNameJsonReady((nameJson) => {
			this.getInfosInit(nameJson);
		});
	}

	getInfosInit(_nameJson: any) {
		// Get Settings
		this.app.sharedToolsService.getSettings();

		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the texts
			this.app.sharedToolsService.loadTexts(_nameJson)
				.subscribe(textes => {
					this.textes = textes;

					this.prmSurfacesNiveau = this.textes.prmSurfacesNiveau;
					this.prmDpe = this.textes.prmDpe;

					// Retrieve the building data from localStorage
					this.batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
					if (this.batiment) console.log("this.batiment:", this.batiment);

					// Replace the value and add the items to a formatted array if the property exists
					if (this.batiment) {
						if (!this.batiment.nbEtages) this.batiment.nbEtages = 1;
						if (!this.batiment.hauteurPlafond) this.batiment.hauteurPlafond = 2.5;

						// Global params
						if (this.textes.arrParamsBien) {
							setTimeout(() => {
								this.textes.arrParamsBien.forEach((k: any) => {
									k.value = this.getValueParamBien(k.id, this.batiment, 'value');
									k.options = this.getValueParamBien(k.id, this.batiment, 'options');

									k.value = (this.app.sharedToolsService.isNullOrUndefined(k.value)) ? null : k.value;

									if (!this.idExists(k.id, this.arrParamsBienFormatted)) {
										this.arrParamsBienFormatted.push(k);
										//this.arrParamsBienFormattedIni.push(k);
									}
								});

								this.arrParamsBienFormattedIni = _.cloneDeep(this.arrParamsBienFormatted);
								console.log('this.arrParamsBienFormatted / this.arrParamsBienFormattedIni ==>', this.arrParamsBienFormatted, this.arrParamsBienFormattedIni);
							}, 500);
						}

						// NRJ params
						if (this.textes.arrParamsNrj) {
							setTimeout(() => {
								this.textes.arrParamsNrj.forEach((k: any) => {
									k.value = this.getValueParamBien(k.id, this.batiment, 'value');
									k.options = this.getValueParamBien(k.id, this.batiment, 'options');

									k.value = (this.app.sharedToolsService.isNullOrUndefined(k.value)) ? null : k.value;

									if (!this.idExists(k.id, this.arrParamsNrjFormatted)) {
										this.arrParamsNrjFormatted.push(k);
										//this.arrParamsNrjFormattedIni.push(k);
									}
								});

								this.arrParamsNrjFormattedIni = _.cloneDeep(this.arrParamsNrjFormatted);
								console.log('this.arrParamsNrjFormatted / this.arrParamsNrjFormattedIni ==>', this.arrParamsNrjFormatted, this.arrParamsNrjFormattedIni);
							}, 500);
						}
					}
				});
		});
	}

	onKeyUp(_type: any, _value: any, _event: any) {
		//if (_type.id != 1004) return;

		if (_type.id === 1004) {
			this.batiment.surface = _type.value;
			//console.log("batiment-->", this.batiment);
			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
		} else if (_type.id === 1006) {
			this.batiment.hauteurPlafond = _type.value;
			//console.log("batiment-->", this.batiment);
			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
		}
	}

	private updateTypeValue(_type: any, increment: number) {
		let minValue = _type.id == 1004 ? 1 : 0.1;
		let newValue = Math.round(increment * 100) / 100;

		if (newValue > minValue) {
			_type.value = newValue;
			if (_type.id === 1004) {
				this.batiment.surface = newValue;
			} else if (_type.id === 1006) {
				this.batiment.hauteurPlafond = newValue;
			}
			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
		}
	}

	getMinus(_type: any) {
		const increment = _type.id == 1004 ? 1 : 0.1;
		this.updateTypeValue(_type, +_type.value - increment);
		//console.log("Minus ☺", _type.value)
	}

	getPlus(_type: any) {
		const increment = _type.id == 1004 ? 1 : 0.1;
		this.updateTypeValue(_type, +_type.value + increment);
		//console.log("Plus ☻", _type.value)
	}

	idExists(_id: any, _array: any) {
		return _array.some(function (el: any) {
			return el.id === _id;
		});
	}

	onRating(_type: any, _optValue: any) {
		_type.value = _optValue;
		this.batiment.niveauStanding = _type.value;
		//console.log("batiment-->", this.batiment);
		localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
		// console.log('this.arrParamsBienFormatted ======> ', this.arrParamsBienFormatted);
	}

	getValueParamBien(_id: number, _bien: any, _returned: any) {
		if (!this.options) return null;

		let value: any;
		let options: any;

		switch (_id) {

			case 1001:
				value = _bien.type;
				options = this.options.optsTypeBien;
				break;

			case 1002:
				value = _bien.anneeConstruction; //anneeConst
				options = this.options.optsAnneeConstruct;
				break;

			case 1003:
				value = _bien.pieces; //nbPieces
				options = this.options.optsNbPieces;
				break;

			case 1004:
				value = _bien.surface; //srf
				options = [];
				break;

			case 1005:
				value = _bien.nbEtages;
				options = this.options.optsNbEtages;
				break;

			case 1006:
				value = _bien.hauteurPlafond; //hautPlafond
				options = [];
				break;

			case 1007:
				value = _bien.typeChaufage; //typeChauff
				options = this.options.optsTypeChauffage;
				break;

			case 1008:
				value = _bien.niveauStanding; //nivStanding
				options = this.options.optsNivStanding;
				break;

			case 2001:
				value = _bien.niveauIsolation;
				options = this.options.optsNivIsolation;
				break;

			case 2002:
				value = _bien.mursMitoyens;
				options = this.options.optsMursMitoyens;
				break;

			case 2003:
				value = _bien.isoPlancher;
				options = this.options.optsIsoPlancher;
				break;

			case 2004:
				value = _bien.isoPlafonds;
				options = this.options.optsIsoPlafonds;
				break;

			case 2005:
				value = _bien.typeVmc;
				options = [];
				break;

			default:
				break;
		}

		console.log("value", value);
		console.log("options", options);

		return (_returned == "value") ? value : options;
	}

	// Fct pour le nb de niveaux
	getIfNbNiveauxIsOk() {
		//|| !this.batiment.surfacesNiveau
		if (!this.batiment || !this.batiment.nbEtages) return true;

		let isOk = false;
		let surfaces = this.batiment.surfacesNiveau!.split(';');

		if (surfaces.length > 2) surfaces.splice(2);

		this.batiment.surfacesNiveau = surfaces.join(';');
		localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
		// console.log("surfaces ==> ", surfaces)
		isOk = surfaces.length == 2 || (surfaces.length == 1 && this.batiment.nbEtages == 1);

		return isOk;
	}

	onCloseBulleNbNiveaux() {
		this.prmSurfacesNiveau.options = [];
		this.showSelectNbNiveaux = false;
	}

	showOrHideButtonValidateNbNiveaux(nbNiveau?: number) {

		let isFormOk = true;

		for (let i = 0; i < 2!; i++) {
			isFormOk = isFormOk && this.prmSurfacesNiveau.options[i].value && this.prmSurfacesNiveau.options[i].value > 0
		}

		return isFormOk;
	}

	validateNbNiveaux(nbNiveau?: number) {
		console.log("this.prmSurfacesNiveau ==>", this.prmSurfacesNiveau);

		this.prmSurfacesNiveau.value = "";

		let isFormOk = true;
		for (let i = 0; i < 2; i++) {
			isFormOk = isFormOk && this.prmSurfacesNiveau.options[i].value && this.prmSurfacesNiveau.options[i].value > 0;

			if (this.prmSurfacesNiveau.options[i].value)
				this.prmSurfacesNiveau.value += this.prmSurfacesNiveau.options[i].value.toString() + ";"
		}

		if (!isFormOk) {
			this.prmSurfacesNiveau.value = "";
			return;
		}

		console.log("this.prmSurfacesNiveau.value ==>", this.prmSurfacesNiveau.value);

		setTimeout(() => {
			this.prmSurfacesNiveau.options = [];
			this.batiment.surfacesNiveau = this.prmSurfacesNiveau.value;
			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
			this.showSelectNbNiveaux = false;
		}, 100);
	}

	onChangeNbNiveaux(nbNiveau?: number) {
		if (this.app.sharedToolsService.isNullOrUndefined(nbNiveau) || nbNiveau == 1) {
			this.showSelectNbNiveaux = false;
			this.prmSurfacesNiveau.options = [];
			this.batiment.surfacesNiveau = this.batiment.surface?.toString() || "";
			return;
		}

		this.showSelectNbNiveaux = true;
		console.log("nbNiveau ==> ", nbNiveau);
		console.log("this.batiment.surfacesNiveau ==>", this.batiment.surfacesNiveau);

		const surfaces = (this.batiment.surfacesNiveau) ? this.batiment.surfacesNiveau.split(';') : [];
		console.log("surfaces ==> ", surfaces);

		if (nbNiveau > 1) {
			this.prmSurfacesNiveau.options.push({
				id: 1,
				label: 'RDC',
				value: (surfaces[0]) ? parseInt(surfaces[0]) : 0
			});

			this.prmSurfacesNiveau.options.push({
				id: 2,
				label: 'Dernier étage',
				value: (surfaces[1]) ? parseInt(surfaces[1]) : 0
			});
			console.log("this.prmSurfacesNiveau.options ==> ", this.prmSurfacesNiveau.options);
		}

		// Old Code
		// for (let i = 0; i < nbNiveau; i++) {
		// 	if (!this.prmSurfacesNiveau.options.some((option: any) => option.id === i + 1)) {
		// 		this.prmSurfacesNiveau.options.push({
		// 			id: i + 1,
		// 			label: 'Niveau ' + (i + 1).toString(),
		// 			//label: (i == 0) ? 'RDC' : 'Dernier étage',
		// 			value: (surfaces[i]) ? parseInt(surfaces[i]) : 0
		// 		});
		// 	}
		// 	if (this.prmSurfacesNiveau.options.length > nbNiveau) {
		// 		this.prmSurfacesNiveau.options.splice(nbNiveau);
		// 	}
		// }
	}

	// Fct pour le dpe
	onCloseBulleDep() {
		//this.prmDpe.options = [];
		this.showSelectDpe = false;
	}

	validateDpe(_dpe?: string) {
		console.log("validateDpe ==>", _dpe);
		this.showSelectDpe = false;
	}

	onChangTypeChauffage(typeChValue: any) {
		console.log("typeChValue--->", typeChValue);

		if (this.app.sharedToolsService.isNullOrUndefined(typeChValue)) {
			this.showSelectDpe = false;
			return;
		}

		this.showSelectDpe = true;
	}

	// On change select générale
	onChange(event: any, id: number, value: any, batType: any) {
		console.log("event.target--->", event.target)
		console.log("id--->", id)
		console.log("value--->", value)
		console.log("batType---", batType)

		switch (id) {
			case 1001:
				this.batiment.type = JSON.parse(event.target.value);
				if (parseInt(event.target.value) != 3 && parseInt(event.target.value) != 5 && parseInt(event.target.value) != 6) //pas une Maison
					this.arrParamsBienFormatted[6].options = _.filter(this.arrParamsBienFormattedIni[6].options, (o) => {
						return o.id != 4 && o.id != 8;
					});
				else
					this.arrParamsBienFormatted[6].options = _.filter(this.arrParamsBienFormattedIni[6].options, (o) => {
						return o.id != 2 && o.id != 6;
					});

				console.log("this.arrParamsBienFormattedIni[6].options:", this.arrParamsBienFormattedIni[6].options);
				break;

			case 1002:
				this.batiment.anneeConstruction = JSON.parse(event.target.value);
				break;

			case 1003:
				this.batiment.pieces = JSON.parse(event.target.value);
				break;

			case 1005:
				this.batiment.nbEtages = JSON.parse(event.target.value);
				this.onChangeNbNiveaux(this.batiment.nbEtages);
				break;

			case 1007:
				this.batiment.typeChaufage = JSON.parse(event.target.value);
				this.batiment.dpe = specialRenovationTypesNrjNb.includes(this.renovationValue) ? "Je ne sais pas" : "";
				//this.onChangTypeChauffage(this.batiment.typeChaufage);
				break;

			case 2001:
				this.batiment.niveauIsolation = JSON.parse(event.target.value);
				break;

			case 2002:
				this.batiment.mursMitoyens = JSON.parse(event.target.value);
				break;

			case 2003:
				this.batiment.isoPlancher = JSON.parse(event.target.value);
				break;

			case 2004:
				this.batiment.isoPlafonds = JSON.parse(event.target.value);
				break;

			case 2005:
				this.batiment.typeVmc = JSON.parse(event.target.checked); //parce qu'il s'agit d'une checkbox
				break;

			default:
				break;
		}

		console.log("batiment-->", this.batiment);
		localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));
	}

	onSubmit() {
		const batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
		console.log("batiment-->", this.batiment, batiment);

		if (this.renovationValue) {
			let old = _.find(this.arrParamsBienFormatted, (prm) => {
				return prm.id == 1009
			});
			//console.log("old:", old);

			if (!old) {
				let prmRenovation: any = {
					id: 1009,
					libelle: "Rénovation",
					img: "",
					value: this.renovationValue,
					type: -1,
					options: []
				}

				this.arrParamsBienFormatted.push(prmRenovation);
			}
		}

		if (batiment.surfacesNiveau) {
			let prev: any = _.find(this.arrParamsBienFormatted, (prm) => {
				return prm.id == 1010
			});
			//console.log("prev:", prev);

			if (!prev) {
				this.arrParamsBienFormatted.push({
					id: 1010,
					libelle: "Surfaces par niveau",
					img: "",
					value: batiment.surfacesNiveau,
					type: -1,
					options: []
				});
			} else {
				prev.value = batiment.surfacesNiveau;
			}
		}

		if (batiment.dpe) {
			let prev: any = _.find(this.arrParamsBienFormatted, (prm) => {
				return prm.id == 1012
			});
			//console.log("prev:", prev);

			if (!prev) {
				this.arrParamsBienFormatted.push({
					id: 1012,
					libelle: "DPE",
					img: "",
					value: batiment.dpe,
					type: -1,
					options: []
				});
			} else {
				prev.value = batiment.dpe;
			}
		}

		// Ajout des parametres énergétiques
		let arrParams = (specialRenovationTypesNrjNb.includes(this.renovationValue))
			? _.unionBy(this.arrParamsBienFormatted, this.arrParamsNrjFormatted, 'id')
			: this.arrParamsBienFormatted;

		//arrParams[7].options = [];
		console.log("arrParams-->", arrParams);

		// Contrôle des champs obligatoires
		let arrayNull: any = [];
		arrParams.forEach((item: any) => {
				//console.log(item.value);
				if (item.value === null && item.id == 2005) item.value = false; //VMC

				if (item.value === null) {
					arrayNull.push(item);
				}
			}
		);
		console.log("arrayNull =========================================>", arrayNull);
		console.log("getIfNbNiveauxIsOk =========================================>", this.getIfNbNiveauxIsOk());

		if (arrayNull.length > 0 || !this.getIfNbNiveauxIsOk()) {
			// console.log('Veuillez sélectionner tout les éléments');
			this.app.confirmDialogService.confirmThis("", this.modalsTxt.modalAllFieldsOblig, "alert", "", () => {
				console.log("Yes clicked");
			}, () => {
				console.log("No clicked");
			});

			return;
		}

		// Recupération du libellé du type de batiment
		let type_bien = this.options.optsTypeBien.find((o: any) => o.id == this.batiment.type);
		// Tracking Analytics : Type de batiment
		this.analyticsService.trackEvent('user_interaction', 'click_type_bien', 'value : ' + type_bien?.label);

		var param = {
			adr: this.batiment.adress,
			cp: this.batiment.cp,
			ville: this.batiment.ville,
			Params: arrParams,
			// SIM_ID: (!this.batiment.simulationId) ? -1 : parseInt(this.batiment.simulationId)
		}
		console.log("param:", param);

		this.app.apiToolsService.generateSimulationByParam(param).subscribe(simId => {
			console.log("res generateSimulationByParam", simId);

			this.batiment.simulationId = simId.toString();
			localStorage.setItem("BATIMENT", JSON.stringify(this.batiment));

			this.app.sharedToolsService.goTo(ROUTES_PATHS.PIECES, null);
		});
	}

	public readonly specialRenovationTypesNrjNb = specialRenovationTypesNrjNb;
}
